// extracted by mini-css-extract-plugin
module.exports =  {"emptyCategory":"fhc4Ns","titleSub":"SuCR8R","bodySub":"ijMG3o","link":"jiMU7g"};